import { forEach, isEmpty } from 'lodash/fp';
import { FormikValues } from 'formik';

import browserUtils from '../../../../utils/browser';
import hasSessionDataToRehydrate from '../has-session-data-to-rehydrate';

type RehydrateFormParams<T> = {
  hasPersistedEventRun?: boolean;
  resetForm: (values: FormikValues) => void;
  setSubmitting: (value: boolean) => void;
  setHasFormInitialized: (value: boolean) => void;
  hasInputComponent: boolean;
  hasInputDataLoaded: boolean;
  hasFormInitialized: boolean;
  valuesFromUrl?: Partial<T> | null;
  formikSessionStorageKey: string;
  sessionStorageKeys?: {};
};

const runSetValueForSessionKeys = (sessionStorageKeys: any): void => {
  forEach(({ setValue, key }) => {
    if (setValue) {
      setValue(key);
    }
  }, sessionStorageKeys);
};

const rehydrateForm = <T>({
  formikSessionStorageKey,
  hasFormInitialized,
  hasInputComponent,
  hasInputDataLoaded,
  hasPersistedEventRun,
  resetForm,
  sessionStorageKeys,
  setHasFormInitialized,
  setSubmitting,
  valuesFromUrl,
}: RehydrateFormParams<T>) => {
  if (hasPersistedEventRun) {
    setHasFormInitialized(false);
    setSubmitting(false);
    return;
  }

  if (hasFormInitialized || (hasInputComponent && !hasInputDataLoaded)) {
    return;
  }
  const { sessionStorage } = browserUtils.getWindow();
  const storedState = sessionStorage.getItem(formikSessionStorageKey);
  const sessionStorageState = storedState ? JSON.parse(storedState) : null;

  const hasAdditionalSessionStorageData = hasSessionDataToRehydrate(sessionStorageKeys);
  if (!sessionStorageState && !valuesFromUrl && !hasAdditionalSessionStorageData) {
    setHasFormInitialized(true);
    return;
  }
  if (!isEmpty(sessionStorageState) || !isEmpty(valuesFromUrl)) {
    resetForm({ values: !isEmpty(sessionStorageState) ? sessionStorageState : valuesFromUrl });
  }

  if (sessionStorageKeys) {
    runSetValueForSessionKeys(sessionStorageKeys);
  }

  setSubmitting(false);
  setHasFormInitialized(true);
};

export default rehydrateForm;
